module.exports = __webpack_public_path__ + "img/achievement2.a412f136.jpg";